import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../../Messages";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {UserPreferencesStore, WalletStore} from "../../../../State";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {Money} from "../../../../../client/state/misc/Money";
import {AnchoredPopup, AnchoredPopupStyle} from "../../../../ui/AnchoredPopup";
import {WidgetWalletTheme} from "../../../WidgetTheme.js";


class WalletTooltipStyle extends AnchoredPopupStyle {
    @styleRuleInherit
    popup = {
        color: this.themeProps.WALLET_2,
        padding: 12,
        width: 256,
    };
}

@registerStyle(WalletTooltipStyle)
export class AutoReloadPopup extends AnchoredPopup {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            offset: 10,
            theme: WidgetWalletTheme,
        };
    }

    render() {
        const {autoTopUpAmount, autoTopUpThreshold} = UserPreferencesStore.getPreferences();
        const currency = WalletStore.getWallet().getCurrency();
        const {styleSheet} = this;

        return <div className={styleSheet.message}>
            {Messages.autoReloadWallet(new Money(autoTopUpAmount, currency), new Money(autoTopUpThreshold, currency))}
        </div>;
    }
}
